import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

export default function AuditPage() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get('/audit').then(r => setLogs(r.data)); }, []);

  return (
    <div className="py-6 max-w-5xl mx-auto space-y-4" data-testid="audit-page">
      <div>
        <div className="overline">Governance</div>
        <h1 className="font-serif text-4xl">Audit log</h1>
        <p className="text-slate-600 mt-2">Every action, every actor, immutable.</p>
      </div>
      <div className="glass p-6">
        <table className="w-full text-sm">
          <thead><tr className="overline text-left border-b border-slate-200/60">
            <th className="py-2">When</th><th>User</th><th>Action</th><th>Entity</th></tr></thead>
          <tbody>
            {logs.map(l => (
              <tr key={l.id} className="border-b border-slate-100/70">
                <td className="py-2 text-xs text-slate-500">{new Date(l.created_at).toLocaleString()}</td>
                <td>{l.user_name}</td>
                <td><span className="status-pill status-neutral">{l.action}</span></td>
                <td className="text-xs">{l.entity_type}/{l.entity_id.slice(0,10)}…</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={4} className="py-8 text-center text-slate-400">No activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
